import React, { useState } from 'react';

import { Button } from '../atoms/Button';
import { Input } from '../atoms/Input';

interface LoginFormData {
  email: string;
  password: string;
  name: string;
}

interface LoginFormProps {
  onSubmit: (formData: LoginFormData) => void;
  onToggleMode: () => void;
  isSignup: boolean;
  disabled?: boolean;
}

export const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, onToggleMode, isSignup, disabled }) => {
  const [formData, setFormData] = useState<LoginFormData>({ email: '', password: '', name: '' });
  const [errors, setErrors] = useState<Partial<LoginFormData>>({});

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const newErrors: Partial<LoginFormData> = {};

    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.password) newErrors.password = 'Password is required';
    if (isSignup && !formData.name) newErrors.name = 'Name is required';

    if (Object.keys(newErrors).length === 0) {
      onSubmit(formData);
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
      {isSignup && (
        <Input
          label="Full Name"
          type="text"
          value={formData.name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, name: e.target.value })}
          error={errors.name}
          data-testid="name-input"
        />
      )}
      <Input
        label="Email"
        type="email"
        value={formData.email}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, email: e.target.value })}
        error={errors.email}
        data-testid="email-input"
      />
      <Input
        label="Password"
        type="password"
        value={formData.password}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFormData({ ...formData, password: e.target.value })}
        error={errors.password}
        data-testid="password-input"
      />
      <Button type="submit" className="w-full" disabled={disabled} data-testid="submit-button">
        {isSignup ? 'Sign Up' : 'Login'}
      </Button>
      <Button type="button" variant="ghost" className="w-full" onClick={onToggleMode} data-testid="toggle-mode-button">
        {isSignup ? 'Already have an account? Login' : "Don't have an account? Sign Up"}
      </Button>
    </form>
  );
};